import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  runFileAction,
} from '../../../actions/Mini';

import { isMiniAdobeIntegration } from '../../../helpers/App';

import FileMiniActionsAction from './Actions/Action';
import FileMiniActionsSuperAction from './Actions/SuperAction';

const FileMiniActions = ({
  dispatch,
  miniConfig,
  collection,
  availableActions,
  lockFileUuid,
  file,
}) => {
  if (availableActions.length === 0) {
    return null;
  }

  const showActions = availableActions
    .filter(a => !a.actionbar)
    .filter(a => {
      if (isMiniAdobeIntegration() && miniConfig.integrationId === 'adobe-indesign') {
        if (!collection && a.id === 'open-package') return false;
      }

      return true;
    });

  const runAction = (action) => {
    dispatch(runFileAction(file, action));
  };

  return (
    <div className="file-actions">
      <ul>
        {showActions.map(action => (
          <FileMiniActionsAction
            key={action.id}
            action={action}
            file={file}
            fileLocked={lockFileUuid === file.uuid}
            runAction={runAction}
          />
        ))}
        <FileMiniActionsSuperAction
          file={file}
          fileLocked={lockFileUuid === file.uuid}
        />
      </ul>
    </div>
  );
};

const mapStateToProps = state => ({
  miniConfig: state.Mini.config,
  collection: state.Collections.collection,
  fileAction: state.Mini.fileAction,
  lockFileUuid: state.Mini.lockFileUuid,
});

FileMiniActions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  miniConfig: PropTypes.object.isRequired,
  collection: PropTypes.object,
  lockFileUuid: PropTypes.string,
  availableActions: PropTypes.array,
  file: PropTypes.object.isRequired,
};

FileMiniActions.defaultProps = {
  collection: null,
  lockFileUuid: null,
  availableActions: [],
};

export default connect(mapStateToProps)(FileMiniActions);
